export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5362.c3cc68f9.jpg";